import { Trans } from 'react-i18next';
import { cn } from '../../utils/cn';
import { useCurrentLang } from '../../hooks/useCurrentLang';
import { getArdshinbankHomeUrl } from '../../utils/ardshinbankUrl';

export default function Footer({ className }: { className?: string }) {
    const lang = useCurrentLang();

    return (
        <footer
            className={cn('shrink-0 text-left text-xs text-secondary', className)}
            role="contentinfo"
        >
            <Trans
                i18nKey="registrationCopyrightFooter"
                values={{ year: new Date().getFullYear() }}
                components={{
                    website: (
                        <a
                            href={getArdshinbankHomeUrl(lang)}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="underline"
                        />
                    ),
                }}
            />
        </footer>
    );
}
